// core
import HomeLayout from "@/components/HomeLayout";
import { CommonRouteObject } from "./routerGenerator";
import Home from "@/pages/home";
import News from "@/pages/news";
import Solutions from "@/pages/solutions";
import Cooperation from "@/pages/cooperation";
import AboutUs from "@/pages/aboutUs";
import CooperationCases from "@/pages/cooperationCases";
import AIMarketing from "@/pages/aiMarketing";
import Machine from "@/pages/machine";
import InteractiveIP from "@/pages/interactiveIP";
import AIBeings from "@/pages/aiBeings";
import AgentX from "@/pages/agentx";
import JoinUs from "@/pages/joinUs";
import Developer from "@/pages/developer";
import Live from "@/pages/live";
import Yiqiliao from "@/pages/yiqiliao";
import Geo from "@/pages/geo";
import ContactPage from "@/pages/contact";

export const routes: CommonRouteObject[] = [
  {
    path: "/",
    element: <HomeLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "aiBeings",
        element: <AIBeings />,
      },
      {
        path: "aiMarketing",
        element: <AIMarketing />,
      },
      {
        path: "machine",
        element: <Machine />,
      },
      {
        path: "interactiveIP",
        element: <InteractiveIP />,
      },
      {
        path: "agentx",
        element: <AgentX />,
      },
      {
        path: "yiqiliao",
        element: <Yiqiliao />,
      },
      {
        path: "geo",
        element: <Geo />,
      },
      {
        path: "developer",
        element: <Developer />,
      },
      {
        path: "live",
        element: <Live />,
      },
      {
        path: "/news",
        element: <News />,
      },
      {
        path: "/solutions",
        element: <Solutions />,
      },
      {
        path: "/cooperation",
        children: [
          {
            index: true,
            element: <Cooperation />,
          },
          {
            path: "cases",
            element: <CooperationCases />,
          },
        ],
      },
      {
        path: "/aboutUs",
        element: <AboutUs />,
      },
      {
        path: "/joinUs",
        element: <JoinUs />,
      },
    ],
  },
  {
    path: "*",
    element: <>404</>,
  },
  {
    path: "/contact",
    element: <HomeLayout onlyBody />,
    children: [
      {
        index: true,
        element: <ContactPage />,
      },
    ],
  },
];
